import {EventParticipant, GroupAvatar, Participating, UserAvatar} from "@/lib/types";
import AvatarRow from "@/lib/components/AvatarRow";
import {Color, rowColor} from "@/lib/styles";
import AvatarTable from "@/lib/components/AvatarTable";

type Props = {
    participants: EventParticipant[],
    color: string,
    contrastColor: string,
    colored: boolean,
    onPress: (avatar: UserAvatar | GroupAvatar) => any,
    onEdit?: (username: string) => any,
}

export default function ParticipantTable({participants, color, contrastColor, colored, onPress, onEdit}: Props) {
    const baseColor = colored ? color : Color.Container;

    function badge(participant: EventParticipant): string | undefined {
        if (participant.status === Participating.HOST) {
            return 'Arrangør';
        } else if (participant.status === Participating.MODERATOR) {
            return 'Moderator';
        }
    }

    return (
        <AvatarTable>
            {participants.map((participant, index) => (
                <AvatarRow key={participant.avatar.id}
                           avatar={participant.avatar}
                           badge={badge(participant)}
                           badgeColor={color}
                           color={rowColor(baseColor, index)}
                           contrastColor={contrastColor}
                           onPress={onPress}
                           onEdit={onEdit ? onEdit(participant.avatar.username) : undefined}
                />
            ))}
        </AvatarTable>
    )
}